import { useSessionStorageValue } from "@react-hookz/web";
import { sessionStorageKeys } from "../../utils/storageKeys";

export const useFieldGroupsFilter = () =>
  useSessionStorageValue<string[]>(
    sessionStorageKeys.calendarFiltersFieldGroups,
    {
      defaultValue: [],
      initializeWithValue: true,
    }
  );

export const useTasksFilter = () =>
  useSessionStorageValue<string[]>(sessionStorageKeys.calendarFiltersTasks, {
    defaultValue: [],
    initializeWithValue: true,
  });

export const useFieldsFilter = () =>
  useSessionStorageValue<string[]>(sessionStorageKeys.calendarFiltersFields, {
    defaultValue: [],
    initializeWithValue: true,
  });

export const useUsersFilter = () =>
  useSessionStorageValue<string[]>(sessionStorageKeys.calendarFiltersUsers, {
    defaultValue: [],
    initializeWithValue: true,
  });

export const useMachinesFilter = () =>
  useSessionStorageValue<string[]>(sessionStorageKeys.calendarFiltersMachine, {
    defaultValue: [],
    initializeWithValue: true,
  });

export const useSelectedDate = (defaultSelectedDate: Date) =>
  useSessionStorageValue<Date>(sessionStorageKeys.calendarSelectedDate, {
    defaultValue: defaultSelectedDate,
    stringify: (value) => JSON.stringify(value),
    parse: (value) => {
      if (value == null) return defaultSelectedDate;
      const dateString = JSON.parse(value);
      return new Date(dateString);
    },
    initializeWithValue: false,
  });

export const useShowHeatMaps = () =>
  useSessionStorageValue<boolean>(sessionStorageKeys.calendarShowHeatMaps, {
    defaultValue: false,
    initializeWithValue: false,
  });

export const useColorTasksPerAssiciatedUsers = () =>
  useSessionStorageValue<boolean>(
    sessionStorageKeys.calendarColorTasksPerAssociatedUsers,
    {
      defaultValue: true,
      initializeWithValue: false,
    }
  );

export const useStartCalendarOnSelectedDate = () =>
  useSessionStorageValue<boolean>(
    sessionStorageKeys.calendarStartCalendarOnSelectedDate,
    {
      defaultValue: false,
      initializeWithValue: false,
    }
  );

export const useDaysToDisplay = () =>
  useSessionStorageValue<"1" | "3" | "7" | "10">("daysToDisplay", {
    defaultValue: "7",
    initializeWithValue: false,
  });
